import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import PageHeader from '../components/PageHeader';
import StatusBadge from '../components/StatusBadge';
import { AISidebar, AIInsightCard } from '../components/ai';
import { Input } from '../components/ui/Input';
import { Textarea } from '../components/ui/Textarea';
import { Toggle } from '../components/ui/Toggle';
import { Button } from '../components/ui/Button';
import { ArrowLeft, Save, BarChart2, Settings, List, Upload, X, Edit } from 'lucide-react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { rewardsData } from '../utils/rewardsData';
const RewardDetail = () => {
  const {
    rewardId
  } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'settings' | 'codes' | 'performance'>('settings');
  const [isAISidebarOpen, setIsAISidebarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [toast, setToast] = useState<{
    message: string;
    show: boolean;
  }>({
    message: '',
    show: false
  });
  // Get reward data from mock
  const rewardData = rewardsData[rewardId as keyof typeof rewardsData];
  // State for image management
  const [rewardImage, setRewardImage] = useState<string>(rewardId === '1' ? 'https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=400&h=400&fit=crop' : rewardId === '2' ? 'https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=400&h=400&fit=crop' : rewardId === '3' ? 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=400&h=400&fit=crop' : rewardId === '4' ? 'https://images.unsplash.com/photo-1522338242992-e1a54906a8da?w=400&h=400&fit=crop' : rewardId === '5' ? 'https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?w=400&h=400&fit=crop' : rewardId === '6' ? 'https://images.unsplash.com/photo-1607083206968-13611e3d76db?w=400&h=400&fit=crop' : rewardId === '7' ? 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=400&h=400&fit=crop' : rewardId === '8' ? 'https://images.unsplash.com/photo-1596755389378-c31d21fd1273?w=400&h=400&fit=crop' : 'https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=400&h=400&fit=crop');
  const [imageUrl, setImageUrl] = useState<string>('');
  if (!rewardData) {
    return <div className="flex h-screen bg-gray-50" data-id="element-3315">
        <div className="w-20 flex-shrink-0" data-id="element-3316">
          <Sidebar data-id="element-3317" />
        </div>
        <div className="flex-1 flex flex-col overflow-hidden" data-id="element-3318">
          <Topbar data-id="element-3319" />
          <main className="flex-1 overflow-y-auto p-6" data-id="element-3320">
            <div className="text-center py-12" data-id="element-3321">
              <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-3322">
                Premio non trovato
              </h2>
              <button onClick={() => navigate('/rewards')} className="text-green-600 hover:underline" data-id="element-3323">
                Torna ai premi
              </button>
            </div>
          </main>
        </div>
      </div>;
  }
  const [isActive, setIsActive] = useState(rewardData.status === 'Attivo');
  const handleSave = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      setIsEditMode(false);
      setToast({
        message: 'Modifiche salvate',
        show: true
      });
      setTimeout(() => setToast({
        message: '',
        show: false
      }), 3000);
    }, 1000);
  };
  const handleApplyAiSuggestion = () => {
    setToast({
      message: 'Premio aggiornato con suggerimento AI',
      show: true
    });
    setTimeout(() => setToast({
      message: '',
      show: false
    }), 3000);
  };
  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setRewardImage(reader.result as string);
        setToast({
          message: 'Immagine caricata con successo',
          show: true
        });
        setTimeout(() => setToast({
          message: '',
          show: false
        }), 3000);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleImageUrlChange = () => {
    if (imageUrl.trim()) {
      setRewardImage(imageUrl);
      setImageUrl('');
      setToast({
        message: 'Immagine aggiornata',
        show: true
      });
      setTimeout(() => setToast({
        message: '',
        show: false
      }), 3000);
    }
  };
  const handleRemoveImage = () => {
    setRewardImage('https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=400&h=400&fit=crop');
    setToast({
      message: 'Immagine rimossa',
      show: true
    });
    setTimeout(() => setToast({
      message: '',
      show: false
    }), 3000);
  };
  // Calculate utilization percentage
  const utilizationPercentage = rewardData.availability.unlimited ? 0 : (rewardData.availability.total - rewardData.availability.current) / rewardData.availability.total * 100;
  return <div className="flex h-screen bg-gray-50" data-id="element-3324">
      <div className="w-20 flex-shrink-0" data-id="element-3325">
        <Sidebar data-id="element-3326" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-3327">
        <Topbar data-id="element-3328" />
        <main className="flex-1 overflow-y-auto p-6" data-id="element-3329">
          <div className="mb-6" data-id="element-3330">
            <button onClick={() => navigate('/rewards')} className="flex items-center text-sm text-gray-500 hover:text-gray-900 mb-4" data-id="element-3331">
              <ArrowLeft className="h-4 w-4 mr-1" data-id="element-3332" />
              Torna ai premi
            </button>

            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-3333">
              <div data-id="element-3334">
                <div className="flex items-center gap-3 mb-1" data-id="element-3335">
                  <h1 className="text-2xl font-bold text-gray-900" data-id="element-3336">
                    {rewardData.name}
                  </h1>
                  <StatusBadge status={rewardData.status} type="reward" data-id="element-3337" />
                </div>
                <p className="text-sm text-gray-500" data-id="element-3338">
                  ID: {rewardData.id} • {rewardData.type}
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-3339">
                {!isEditMode ? <Button variant="secondary" onClick={() => setIsEditMode(true)} leftIcon={<Edit className="h-4 w-4" data-id="element-3341" />} data-id="element-3340">
                    Modifica
                  </Button> : <>
                    <div className="flex items-center bg-white border border-gray-200 rounded-lg px-3 py-2" data-id="element-3342">
                      <span className="text-sm font-medium text-gray-700 mr-3" data-id="element-3343">
                        Stato:
                      </span>
                      <Toggle label="" checked={isActive} onChange={setIsActive} data-id="element-3344" />
                      <span className="text-sm text-gray-600 ml-2" data-id="element-3345">
                        {isActive ? 'Attivo' : 'Inattivo'}
                      </span>
                    </div>
                    <Button variant="secondary" onClick={() => setIsEditMode(false)} data-id="element-3346">
                      Annulla
                    </Button>
                    <Button variant="primary" onClick={handleSave} isLoading={isLoading} leftIcon={<Save className="h-4 w-4" data-id="element-3348" />} data-id="element-3347">
                      Salva modifiche
                    </Button>
                  </>}
              </div>
            </div>
          </div>

          {/* AI Insight Card */}
          {rewardData.aiHint && <div className="mb-6" data-id="element-3349">
              <AIInsightCard title="AI: Suggerimento per questo premio" insights={[rewardData.aiHint.text, rewardData.aiHint.explanation]} ctaLabel="Applica modifica" onCtaClick={handleApplyAiSuggestion} lastUpdated="Ultimi 7 giorni" data-id="element-3350" />
            </div>}

          {/* Tabs */}
          <div className="border-b border-gray-200 mb-6" data-id="element-3351">
            <nav className="-mb-px flex space-x-8" data-id="element-3352">
              <button onClick={() => setActiveTab('settings')} className={`flex items-center whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'settings' ? 'border-green-600 text-green-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3353">
                <Settings className="h-4 w-4 mr-2" data-id="element-3354" />
                Impostazioni
              </button>
              <button onClick={() => setActiveTab('codes')} className={`flex items-center whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'codes' ? 'border-green-600 text-green-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3355">
                <List className="h-4 w-4 mr-2" data-id="element-3356" />
                Codici / Disponibilità
              </button>
              <button onClick={() => setActiveTab('performance')} className={`flex items-center whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'performance' ? 'border-green-600 text-green-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3357">
                <BarChart2 className="h-4 w-4 mr-2" data-id="element-3358" />
                Performance
              </button>
            </nav>
          </div>

          {/* Tab Content */}
          <div className="space-y-6" data-id="element-3359">
            {activeTab === 'settings' && <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-3360">
                <div className="lg:col-span-2 space-y-6" data-id="element-3361">
                  {/* Image Upload Section */}
                  <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3362">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-3363">
                      Immagine Premio
                    </h3>
                    <div className="space-y-4" data-id="element-3364">
                      {/* Current Image Preview */}
                      <div className="flex items-start gap-4" data-id="element-3365">
                        <div className="relative" data-id="element-3366">
                          <img src={rewardImage} alt={rewardData.name} className="w-32 h-32 rounded-lg object-cover border-2 border-gray-200" data-id="element-3367" />
                          {rewardImage && isEditMode && <button onClick={handleRemoveImage} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition-colors" title="Rimuovi immagine" data-id="element-3368">
                              <X className="h-4 w-4" data-id="element-3369" />
                            </button>}
                        </div>
                        <div className="flex-1" data-id="element-3370">
                          <p className="text-sm text-gray-600 mb-3" data-id="element-3371">
                            Carica un'immagine per il premio. Formato
                            consigliato: JPG, PNG. Dimensione massima: 5MB.
                          </p>
                          {isEditMode && <label className="inline-flex items-center px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 cursor-pointer transition-colors" data-id="element-3372">
                              <Upload className="h-4 w-4 mr-2" data-id="element-3373" />
                              Carica Immagine
                              <input type="file" accept="image/*" onChange={handleImageUpload} className="hidden" data-id="element-3374" />
                            </label>}
                        </div>
                      </div>

                      {/* URL Input */}
                      {isEditMode && <div className="pt-4 border-t border-gray-200" data-id="element-3375">
                          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3376">
                            Oppure inserisci URL immagine
                          </label>
                          <div className="flex gap-2" data-id="element-3377">
                            <input type="url" value={imageUrl} onChange={e => setImageUrl(e.target.value)} placeholder="https://esempio.com/immagine.jpg" className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-3378" />
                            <button onClick={handleImageUrlChange} disabled={!imageUrl.trim()} className="px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-3379">
                              Applica
                            </button>
                          </div>
                        </div>}
                    </div>
                  </div>

                  <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3380">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-3381">
                      Informazioni Generali
                    </h3>
                    <div className="space-y-4" data-id="element-3382">
                      <Input label="Nome premio" defaultValue={rewardData.name} readOnly={!isEditMode} data-id="element-3383" />
                      <Textarea label="Descrizione breve" rows={3} defaultValue={rewardData.description} readOnly={!isEditMode} data-id="element-3384" />
                      <Textarea label="Termini e Condizioni" rows={3} defaultValue={rewardData.terms} readOnly={!isEditMode} data-id="element-3385" />
                    </div>
                  </div>

                  <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3386">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-3387">
                      Validità
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3388">
                      <Input label="Data inizio" type="date" defaultValue={rewardData.startDate || ''} readOnly={!isEditMode} data-id="element-3389" />
                      <Input label="Data fine" type="date" defaultValue={rewardData.endDate || ''} readOnly={!isEditMode} data-id="element-3390" />
                    </div>
                  </div>
                </div>

                <div className="space-y-6" data-id="element-3391">
                  <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3392">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-3393">
                      Configurazione
                    </h3>
                    <div className="space-y-4" data-id="element-3394">
                      <Input label="Costo in Crediti" type="number" defaultValue={rewardData.cost} readOnly={!isEditMode} data-id="element-3395" />
                      <div className="pt-2" data-id="element-3396">
                        <Toggle label="Limite per utente" description="1 per utente" checked={rewardData.limitPerUser} onChange={() => {}} disabled={!isEditMode} data-id="element-3397" />
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3398">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-3399">
                      Sedi
                    </h3>
                    <div className="space-y-2" data-id="element-3400">
                      {rewardData.locations.map((location, index) => <div key={index} className="flex items-center" data-id="element-3401">
                          <input type="checkbox" checked disabled={!isEditMode} className="h-4 w-4 text-green-600 rounded border-gray-300" readOnly data-id="element-3402" />
                          <span className="ml-2 text-sm text-gray-700" data-id="element-3403">
                            {location}
                          </span>
                        </div>)}
                    </div>
                  </div>
                </div>
              </div>}

            {activeTab === 'codes' && <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3404">
                <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-3405">
                  Codici e Disponibilità
                </h3>

                {/* Codice Premio */}
                <div className="mb-6" data-id="element-3406">
                  <Input label="Codice Premio" value={rewardData.code} readOnly data-id="element-3407" />
                  <p className="text-xs text-gray-500 mt-1" data-id="element-3408">
                    Codice univoco per identificare questo premio
                  </p>
                </div>

                {rewardData.availability.unlimited ? <div className="bg-blue-50 rounded-lg p-4 border border-blue-200" data-id="element-3409">
                    <p className="text-sm font-medium text-blue-900" data-id="element-3410">
                      Disponibilità Illimitata
                    </p>
                    <p className="text-sm text-blue-700 mt-1" data-id="element-3411">
                      Questo premio non ha limiti di disponibilità.
                    </p>
                  </div> : <>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-3412">
                      <Input label="Disponibilità Totale" value={rewardData.availability.total} readOnly data-id="element-3413" />
                      <Input label="Disponibilità Rimanente" value={rewardData.availability.current} readOnly data-id="element-3414" />
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-3415">
                      <h4 className="text-sm font-medium text-gray-900 mb-2" data-id="element-3416">
                        Statistiche Utilizzo
                      </h4>
                      <div className="flex items-center justify-between text-sm" data-id="element-3417">
                        <span className="text-gray-500" data-id="element-3418">
                          Totale disponibile:
                        </span>
                        <span className="font-medium" data-id="element-3419">
                          {rewardData.availability.total}
                        </span>
                      </div>
                      <div className="flex items-center justify-between text-sm mt-2" data-id="element-3420">
                        <span className="text-gray-500" data-id="element-3421">Riscattati:</span>
                        <span className="font-medium text-green-600" data-id="element-3422">
                          {rewardData.availability.total - rewardData.availability.current}
                        </span>
                      </div>
                      <div className="flex items-center justify-between text-sm mt-2" data-id="element-3423">
                        <span className="text-gray-500" data-id="element-3424">Rimanenti:</span>
                        <span className="font-medium text-blue-600" data-id="element-3425">
                          {rewardData.availability.current}
                        </span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2 mt-3" data-id="element-3426">
                        <div className="bg-green-600 h-2 rounded-full" style={{
                    width: `${utilizationPercentage}%`
                  }} data-id="element-3427"></div>
                      </div>
                      <p className="text-xs text-gray-500 mt-2" data-id="element-3428">
                        {utilizationPercentage.toFixed(0)}% utilizzato
                      </p>
                    </div>
                  </>}
              </div>}

            {activeTab === 'performance' && <div className="space-y-6" data-id="element-3429">
                {/* KPI Cards */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-3430">
                  <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3431">
                    <p className="text-sm font-medium text-gray-500" data-id="element-3432">
                      Riscatti Totali
                    </p>
                    <p className="text-3xl font-bold text-gray-900 mt-2" data-id="element-3433">
                      {rewardData.redemptions.total}
                    </p>
                    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800 mt-2" data-id="element-3434">
                      {rewardData.redemptions.period} questo periodo
                    </span>
                  </div>
                  <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3435">
                    <p className="text-sm font-medium text-gray-500" data-id="element-3436">
                      Crediti Spesi
                    </p>
                    <p className="text-3xl font-bold text-gray-900 mt-2" data-id="element-3437">
                      {(rewardData.redemptions.total * rewardData.cost).toLocaleString()}
                    </p>
                    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800 mt-2" data-id="element-3438">
                      Valore generato
                    </span>
                  </div>
                  <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3439">
                    <p className="text-sm font-medium text-gray-500" data-id="element-3440">
                      Ultimo Riscatto
                    </p>
                    <p className="text-3xl font-bold text-gray-900 mt-2" data-id="element-3441">
                      {rewardData.redemptions.lastRedemption}
                    </p>
                    <span className="text-sm text-gray-500 mt-2 block" data-id="element-3442">
                      {rewardData.location}
                    </span>
                  </div>
                </div>

                {/* Chart */}
                {rewardData.performanceData.length > 0 ? <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3443">
                    <h3 className="text-lg font-semibold text-gray-900 mb-6" data-id="element-3444">
                      Andamento Riscatti
                    </h3>
                    <div className="h-80" data-id="element-3445">
                      <ResponsiveContainer width="100%" height="100%" data-id="element-3446">
                        <AreaChart data={rewardData.performanceData} data-id="element-3447">
                          <defs data-id="element-3448">
                            <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1" data-id="element-3449">
                              <stop offset="5%" stopColor="#16A34A" stopOpacity={0.1} data-id="element-3450" />
                              <stop offset="95%" stopColor="#16A34A" stopOpacity={0} data-id="element-3451" />
                            </linearGradient>
                          </defs>
                          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" data-id="element-3452" />
                          <XAxis dataKey="date" axisLine={false} tickLine={false} tick={{
                      fill: '#6B7280',
                      fontSize: 12
                    }} dy={10} data-id="element-3453" />
                          <YAxis axisLine={false} tickLine={false} tick={{
                      fill: '#6B7280',
                      fontSize: 12
                    }} data-id="element-3454" />
                          <Tooltip contentStyle={{
                      backgroundColor: '#fff',
                      borderRadius: '8px',
                      border: '1px solid #E5E7EB',
                      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                    }} data-id="element-3455" />
                          <Area type="monotone" dataKey="value" stroke="#16A34A" strokeWidth={2} fillOpacity={1} fill="url(#colorValue)" data-id="element-3456" />
                        </AreaChart>
                      </ResponsiveContainer>
                    </div>
                  </div> : <div className="bg-white rounded-lg border border-gray-200 p-12 shadow-sm text-center" data-id="element-3457">
                    <p className="text-gray-500" data-id="element-3458">
                      Nessun dato disponibile. Il premio non ha ancora riscatti.
                    </p>
                  </div>}
              </div>}
          </div>
        </main>
      </div>

      {/* AI Sidebar */}
      <AISidebar isOpen={isAISidebarOpen} onClose={() => setIsAISidebarOpen(false)} data-id="element-3459">
        {rewardData.aiHint ? <AIInsightCard title="Suggerimento AI per questo premio" insights={[rewardData.aiHint.text, rewardData.aiHint.explanation]} ctaLabel="Applica modifica" onCtaClick={handleApplyAiSuggestion} lastUpdated="Ultimi 7 giorni" data-id="element-3460" /> : <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-3461">
            <p className="text-sm text-gray-600" data-id="element-3462">
              Nessun suggerimento AI disponibile per questo premio al momento.
            </p>
          </div>}
      </AISidebar>

      {/* Toast Notification */}
      {toast.show && <div className="fixed bottom-6 right-6 bg-gray-900 text-white px-6 py-3 rounded-lg shadow-lg z-50 animate-fade-in" data-id="element-3463">
          {toast.message}
        </div>}
    </div>;
};
export default RewardDetail;